<template>
  <div>
    <el-form-item label="帮助内容">
      <el-input type="textarea" v-model="help.content" :autosize="{minRows:2}" resize="none" @change="handleChange"></el-input>
    </el-form-item>
    <el-form-item label="打开方式">
      <el-select v-model="help.open" @change="handleChange">
        <el-option
          v-for="item in openItems"
          :key="item.id"
          :label="item.label"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'HelpInlineForm',
  props: {
    oid: Number,
    value: Object
  },
  watch: {
    value: {
      handler (newVal, oldVal) {
        let help = Object.assign({ content: '', open: 0 }, newVal || {})
        if (help.content === this.help.content && help.open === this.help.open) {
          return
        }
        this.help = help
      },
      immediate: true
    }
  },
  data () {
    return {
      help: {
        content: '',
        open: 0
      },
      openItems: [
        {id: 0, label: '点击按钮打开(默认)'},
        {id: 1, label: '进入页面后打开'}
        // {id: 2, label: '媒体播放完成后打开'}
      ]
    }
  },
  methods: {
    handleChange () {
      this.$emit('input', this.help)
    }
  }
}
</script>
